import { render, staticRenderFns } from "./modal-privacy-policy-freestyle.vue?vue&type=template&id=45bf3268"
import script from "./modal-privacy-policy-freestyle.vue?vue&type=script&lang=js"
export * from "./modal-privacy-policy-freestyle.vue?vue&type=script&lang=js"
import style0 from "./modal-privacy-policy-freestyle.vue?vue&type=style&index=0&id=45bf3268&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports